// extracted by mini-css-extract-plugin
export default {"wrapper":"Redirect_wrapper__4+1+J","imageWrapper":"Redirect_imageWrapper__xjKmS","contentWrapper":"Redirect_contentWrapper__CwfOW"};